import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import logo from "../../../assets/images/circular_logo.jpg";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import "./AdmissionSlip.css";

const AdmissionSlip = () => {
  const { id } = useParams();

  const [student, setStudent] = useState({});
  console.log(student);
  const [loading, setLoading] = useState(true); // Loading state to track fetch completion
  const [date, setDate] = useState(""); // State for current date
  useEffect(() => {
    // Get the current date from the user's computer
    const currentDate = new Date();

    // Format the date as dd mm yyyy
    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    // Set the formatted date
    setDate(formattedDate);
  }, []);
  useEffect(() => {
    if (!loading) {
      window.print();
    }
  }, [loading]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Set the current date in the required format

    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setStudent(response.data);
          setLoading(false);
        }
      } catch (error) {
        // Handle error
      }
    };

    fetchStudentData();
  }, [id]);

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.getElementById("receipt"), {
      callback: function (doc) {
        doc.save("FeeReceipt.pdf");
      },
      x: 10,
      y: 10,
    });
  };

  return (
    <div id="receipt" className="receipt-container">
      <div className="header">
        <div className="logo-container">
          <img src={logo} alt="School Logo" className="logo" />
        </div>
        <h1 className="school-name">SHINE INTERNATIONAL SCHOOL</h1>
        <p className="school-description">
          A Co-educational, English Medium School Based on CBSE Curriculum
        </p>
        <p className="school-location">JAMUDAG, RANCHI</p>
      </div>

      <div className="details-header ">
        <h2>
          <strong>Student ID: </strong>
          {student.student_id}
        </h2>
        <h2>
          <strong>Student Admission Slip</strong>
        </h2>
        <h2>
          <strong>Date:</strong> {date}
        </h2>
      </div>

      <div className="studentDetails">
        <table className="studentDetailsTable">
          <tbody>
            <tr>
              <th>Name</th>
              <td>{student.student_name}</td>
            </tr>
            <tr>
              <th>Roll Number</th>
              <td>{student.class_roll_number}</td>
            </tr>
            <tr>
              <th>Class</th>
              <td>{student.student_class}</td>
            </tr>
            <tr>
              <th>Gender</th>
              <td>{student.gender}</td>
            </tr>
            <tr>
              <th>Date of Birth</th>
              <td>{student.dob}</td>
            </tr>
            <tr>
              <th>Aadhar Number</th>
              <td>{student.aadhar_number}</td>
            </tr>
            <tr>
              <th>Admission Number</th>
              <td>{student.admission_number}</td>
            </tr>
            <tr>
              <th>Date of Admission</th>
              <td>{student.date_of_admission}</td>
            </tr>
            <tr>
              <th>Session</th>
              <td>{student.session}</td>
            </tr>
            <tr>
              <th>Category</th>
              <td>{student.category}</td>
            </tr>
            <tr>
              <th>Blood Group</th>
              <td>{student.blood_group}</td>
            </tr>
            <tr>
              <th>Mother Tongue</th>
              <td>{student.mother_tongue}</td>
            </tr>
            <tr>
              <th>Nationality</th>
              <td>{student.nationality}</td>
            </tr>
            <tr>
              <th>Father's Name</th>
              <td>{student.father_name}</td>
            </tr>
            <tr>
              <th>Father's Contact</th>
              <td>{student.contact_number_father}</td>
            </tr>
            <tr>
              <th>Father's Occupation</th>
              <td>{student.father_occupation}</td>
            </tr>
            <tr>
              <th>Mother's Name</th>
              <td>{student.mother_name}</td>
            </tr>
            <tr>
              <th>Mother's Contact</th>
              <td>{student.contact_number_mother}</td>
            </tr>
            <tr>
              <th>Mother's Occupation</th>
              <td>{student.mother_occupation}</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{student.email}</td>
            </tr>

            <tr>
              <th>Address</th>
              <td>
                {student.address},{student.police_station},{student.post_office}
                ,{student.district},{student.state}-{student.pincode}
              </td>
            </tr>
            <tr>
              <th>Admission Fees Paid</th>
              <td>{student.admission_fees_paid ? "Yes" : "No"}</td>
            </tr>
            <tr>
              <th>Transportation Opted</th>
              <td>{student.admission_fees_paid ? "Yes" : "No"}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="footer-admission-slip">
        <p className="signature">Principal Sign.</p>
        <p className="powered-by">Powered By DevSphire</p>
      </div>
    </div>
  );
};

export default AdmissionSlip;
